import generalMutations from "./generalMutations";
import generalActions from "./generalActions";

export default {
  namespaced: true,
  state: {
    objects: {},
    className: "Turn",
    version: 0,
  },

  mutations: {
    ...generalMutations,
  },
  actions: {
    ...generalActions,
  },
};
